'use strict';

const _ = require('lodash');

const ConfigurationModule = require('./Module');

/**
 * Módulo de configuración: Etiquetas personalizables
 *
 * @param {array} tags Lista fija de etiquetas
 */
class TagsConfiguration extends ConfigurationModule {
    /**
     * Constructor de la clase, inicializa los estados configurables
     *
     * @param  {object} definition Objeto de definición
     */
    constructor(definition = {}) {
        super(definition);

        const { enabled, ...tags } = definition;
        this.tags = tags;
    }

    /**
     * Obtiene la lista de etiquetas
     *
     * @return {array[]} Lista de etiquetas
     *
     */
    getTags() {
        return this.tags;
    }
}

module.exports = TagsConfiguration;
